module.exports = __webpack_public_path__ + "health.svg?c24fccac7858d71def0f706dd46d67a1";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/health.svg
// module id = 108
// module chunks = 0